<script>
  import Popup from '../components/Popup.svelte'
  import { formatPrice } from '../services/utilities.js'

  export var subtotal = 0
  export var shipping = 0
  export var discounts = {
    total: 0,
    coupon_code: '',
  }
  export var taxes = 0
  export var total = 0
  export var giftCard = {
    amount: 0,
    id: '',
    valid: true,
  }

  export var applyAccountBalanceAmount = 0

  export var fees = []

  let msg = ''

  // Cost Summary
  $: feeTotal = fees.reduce((acc, obj) => {
    return acc + obj.price
  }, 0)
  $: total = parseInt(
    subtotal +
      shipping -
      discounts.total +
      feeTotal +
      taxes -
      giftCard.amount -
      applyAccountBalanceAmount,
  )
</script>

<style type="text/less">
  .order-totals {
    display: flex;
  }
  .order-totals ul {
    flex: 0 0 50%;
    margin: 0;

    &:last-child {
      text-align: right;
    }

    li {
      line-height: var(--line-height);
      padding: var(--spacing-xs) 0;

      &:last-child {
        font-size: 1.2rem;
        font-weight: bold;
        line-height: var(--line-height-lg);
        border-top: solid 1px var(--col-text);
      }
    }

    .btn {
      vertical-align: baseline;

      .icon {
        font-size: 1rem;
      }
    }
  }

  .fee {
    height: 3rem;
  }

  @media (max-width: 950px) {
    .fee {
      height: 5rem;
    }
  }
</style>

{#if msg != ''}
  <Popup message={msg} close={() => (msg = '')} />
{/if}

<h2>Order Totals</h2>
<section class="order-totals">
  <ul class="list-unstyled">
    <li>Cart</li>
    <li>Shipping</li>
    {#if discounts.coupon_code != '' && discounts.coupon_code !== null}
      <li>
        Discounts
        <button
          class="btn btn-link"
          on:click={() => (msg = discounts.coupon_code + ': ' + discounts.terms)}>
          <svg class="icon">
            <use href="/icons.svg#info" />
          </svg>
        </button>
      </li>
    {:else}
      <li>Discounts</li>
    {/if}
    {#if giftCard.id != '' && giftCard.id !== null && giftCard.valid}
      <li>
        Gift Card
        <button
          class="btn btn-link"
          on:click={() => (msg = 'Gift Card Code: ' + giftCard.id)}>
          <svg class="icon">
            <use href="/icons.svg#info" />
          </svg>
        </button>
      </li>
    {:else if applyAccountBalanceAmount > 0}
      <li>
        Gift Card
        <button
          class="btn btn-link"
          on:click={() => (msg = 'From your account balance')}>
          <svg class="icon">
            <use href="/icons.svg#info" />
          </svg>
        </button>
      </li>
    {:else}
      <li>Gift Card</li>
    {/if}
    <li>Taxes</li>

    {#if fees.length > 0}
      {#each fees as f}
        <li class="fee">{f.description}</li>
      {/each}
    {/if}

    <li>Total</li>
  </ul>

  <ul class="list-unstyled">
    <li>{formatPrice(subtotal)}</li>
    <li>{formatPrice(shipping)}</li>
    <li>-{formatPrice(discounts.total)}</li>
    {#if applyAccountBalanceAmount > 0}
      <li>-{formatPrice(applyAccountBalanceAmount)}</li>
    {:else}
      <li>-{formatPrice(giftCard.amount)}</li>
    {/if}
    <li>{formatPrice(taxes)}</li>

    <!-- Fees -->
    {#if fees.length > 0}
      {#each fees as f}
        {#if f.price > 0}
          <li class="fee">{formatPrice(f.price)}</li>
        {:else}
          <li class="fee">Included</li>
        {/if}
      {/each}
    {/if}

    <li>{formatPrice(total)}</li>
  </ul>
</section>
